<template>
	<v-row no-gutters class="mx-1">
		<v-col cols="12">
			<div class="category-dropdown custom" v-click-outside="actions.hideDropdown">
				<div class="select-container d-flex align-center justify-space-between" @click="actions.toggleOptions">
					<div class="selected-option">
						<div class="d-flex align-center">
							<img
								v-if="!selectedItem.icon"
								:src="require(`@/assets/icons/stickers_${theme}.png`)"
								class="all-icon"
								alt="Stickers" />
							<img
								v-if="selectedItem.icon"
								:src="require(`@/assets/icons/${selectedItem.icon}.png`)"
								:alt="selectedItem.name"
								class="mr-1" />

							<span
								class="white--text fs--12 fw--500 text-uppercase"
								:class="selectedItem.name.startsWith('All') ? 'ml-2' : 'ml-1'"
								>{{ selectedItem.name }}</span
							>
						</div>
					</div>
					<div class="material-icon">
						<v-icon color="primary" @click="actions.toggleOptions()">{{ icons.mdiChevronDown }}</v-icon>
					</div>
				</div>
				<div class="options dropdown-options" :style="{ maxHeight: isMobile ? '230px' : '320px' }">
					<div
						v-for="item in activeTabs"
						:key="item.index"
						class="option d-flex align-center dropdown-item"
						@click="actions.selectOption(item.index)">
						<img
							v-if="item.icon"
							:src="require(`@/assets/icons/${item.icon}.png`)"
							:alt="item.name"
							class="mr-1" />

						<img
							v-if="!item.icon && item.name.startsWith('All')"
							:src="require(`@/assets/icons/stickers_${theme}.png`)"
							:alt="item.name"
							class="all-icon" />

						<span
							class="white--text fs--12 fw--500 text-uppercase"
							:class="item.name.startsWith('All') ? 'ml-2' : 'ml-1'"
							>{{ item.name }}</span
						>
					</div>
				</div>
			</div>

			<!-- <v-select
				v-model="stickerTab"
				:items="activeTabs"
				background-color="transparent"
				item-text="name"
				item-value="index"
				class="category-dropdown pointer"
				@change="actions.setTab"
				outlined
				attach
				dense
				hide-details
				:menu-props="{ bottom: true, offsetY: true, maxHeight: isMobile ? '162px' : '320px' }">
				<template #prepend-inner>
					<img :src="require(`@/assets/icons/stickers_${theme}.png`)" class="mr-1" alt="Stickers" />
				</template>
				<template #append>
					<v-icon>{{ icons.mdiChevronDown }}</v-icon>
				</template>
				<template v-slot:item="{ item }">
					<div class="d-flex align-center dropdown-item">
						<img
							v-if="item.icon"
							:src="require(`@/assets/icons/${item.icon}.png`)"
							:alt="item.name"
							class="mr-1" />

						<img
							v-if="!item.icon && item.name.startsWith('All')"
							:src="require(`@/assets/icons/stickers_${theme}.png`)"
							:alt="item.name"
							class="mx-1" />

						<span class="white--text fs--12 fw--500 ml-1 text-uppercase">{{ item.name }}</span>
					</div>
					<template v-if="item.isModified">
						<div class="exclamation d-flex align-center justify-center">
							<v-icon size="12" color="white">{{ icons.exclamation }}</v-icon>
						</div>
					</template>
				</template>
				<template v-slot:selection="{ item }">
					<div class="d-flex align-center">
						<img v-if="item.icon" :src="require(`@/assets/icons/${item.icon}.png`)" :alt="item.name" />

						<span class="white--text fs--12 fw--500 ml-1 text-uppercase">{{ item.name }}</span>
					</div>
					<template v-if="item.isModified">
						<div class="exclamation d-flex align-center justify-center">
							<v-icon size="12" color="white">{{ icons.exclamation }}</v-icon>
						</div>
					</template>
				</template>
			</v-select> -->
		</v-col>
	</v-row>
	<!-- <div class="subnav">
		<template v-if="(size === 'sm' && activeTabs.length < 3) || (size === 'md' && activeTabs.length < 4)">
			<v-row no-gutters class="py-2 px-1">
				<v-col
					v-for="(tab, index) in activeTabs"
					:key="tab.name"
					class="px-1"
					:cols="activeTabs.length === 1 ? 12 : activeTabs.length === 2 ? 6 : 4">
					<v-btn
						small
						class=""
						:class="index === stickerTab ? 'active-tab-btn tab-btn' : 'tab-btn'"
						block
						@click="actions.setTab(index)">
						<img
							v-if="tab.icon"
							:src="require(`@/assets/icons/${tab.icon}.png`)"
							:alt="tab.name"
							class="mr-1" />
						{{ tab.name }}

						<template v-if="tab.isModified">
							<div class="exclamation">
								<v-icon size="12" color="white">{{ icons.exclamation }}</v-icon>
							</div>
						</template>
					</v-btn>
				</v-col>
			</v-row>
		</template>

		<template v-else>
			<div class="shadow-left" @mouseenter="actions.moveLeft"></div>
			<v-slide-group
				v-model="stickerTab"
				mandatory
				center-active
				@change="actions.setTab"
				class="px-4 py-2"
				id="slider"
				:show-arrows="true">
				<template #prev>
					<v-icon class="left-slide">{{ icons.mdiChevronLeft }}</v-icon>
				</template>
				<template #next>
					<v-icon class="right-slide">{{ icons.mdiChevronRight }}</v-icon>
				</template>
				<v-slide-item v-for="(tab, index) in activeTabs" :key="index" v-slot="{ active, toggle }">
					<v-btn
						small
						class="mx-1 px-4"
						:class="[active ? 'active-tab-btn tab-btn' : 'tab-btn', !tab.type && 'px-7']"
						@click="toggle">
						<img
							v-if="tab.icon"
							:src="require(`@/assets/icons/${tab.icon}.png`)"
							:alt="tab.name"
							class="mr-1" />
						{{ tab.name }}
					</v-btn>
				</v-slide-item>
			</v-slide-group>
			<div class="shadow-right" @mouseenter="actions.moveRight"></div>
		</template>
	</div> -->
</template>

<script>
import { ref, watch, computed } from 'vue';
import { mdiChevronLeft, mdiChevronRight, mdiChevronDown, mdiExclamationThick } from '@mdi/js';
import { useStore } from '@/store';

export default {
	name: 'StickerSubNav',
	props: {
		tab: {
			type: Number,
			default: 0,
		},
	},
	setup(props, ctx) {
		const stickerTab = ref(0);
		const isOpened = ref(false);
		const store = useStore();

		const size = computed(() => store.state.size);
		const theme = computed(() => store.state.theme);
		const isMobile = computed(() => store.state.isMobile);

		const activeTabs = computed(() => {
			const tabs = [...store.getters.activeTabItems];
			// tabs.push({ name: 'Test 1', index: 90 });
			// tabs.push({ name: 'Test 2', index: 91 });
			// tabs.push({ name: 'Test 3', index: 92 });
			// tabs.push({ name: 'Test 4', index: 93 });
			// tabs.push({ name: 'Test 5', index: 94 });
			// tabs.push({ name: 'Test 6', index: 95 });
			// tabs.push({ name: 'Test 7', index: 96 });

			return tabs.map((item, index) => {
				if (item.name === 'All') {
					item.name = 'All Categories';
				}
				if (item.name === 'TTS') {
					item.name = 'TTS (Text-to-Speech)';
				}
				if (item.name === 'Favorites') {
					item.name = 'My Favorites';
				}

				return { ...item, index };
			});
		});

		const selectedItem = computed(() => {
			return activeTabs.value[stickerTab.value];
		});

		watch(
			() => props.tab,
			val => {
				stickerTab.value = val;
				actions.setTab(val);
			},
		);

		const actions = {
			setSize() {
				setTimeout(() => {
					const elem = document.querySelector('.v-menu__content');
					if (elem) {
						const list = document.querySelector('.v-menu__content .v-list');
						elem.style.minWidth = window.innerWidth - 16 + 'px';
						// list.classList.add('dropdown-list')
					}
				}, 5);
			},
			toggleList: function () {
				const options = document.querySelector('.category-dropdown .options');
				options.style.display = options.style.display === 'block' ? 'none' : 'block';
				isOpened.value = !isOpened.value;
			},
			hideDropdown: function (event) {
				const options = document.querySelector('.category-dropdown .options');
				if (options) {
					options.style.display = 'none';
					isOpened.value = false;
				}
			},
			toggleOptions: function (e) {
				if (e) {
					actions.toggleList();
				}
			},
			selectOption: function (value) {
				stickerTab.value = value;
				actions.toggleList();

				actions.setTab(value);
			},
			setTab: function (value) {
				// if (value || value === 0) {
				// 	stickerTab.value = value;
				// }
				if (value !== null && value >= 0) {
					ctx.emit('change', stickerTab.value);
				}
			},
			moveLeft: function () {
				const slider = document.getElementsByClassName('left-slide')[0];
				slider.click();
			},
			moveRight: function () {
				const slider = document.getElementsByClassName('right-slide')[0];
				slider.click();
			},
		};

		return {
			selectedItem,
			isOpened,

			theme,
			size,
			isMobile,
			stickerTab,
			// tabItems,
			activeTabs,
			actions,
			icons: {
				mdiChevronLeft,
				mdiChevronRight,
				mdiChevronDown,
				exclamation: mdiExclamationThick,
			},
		};
	},
};
</script>

<style lang="scss" scoped>
.exclamation {
	position: absolute;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	top: 6px;
	right: 5px;
	background: red;
	border: 1px solid black;
	color: white;
}
.tab-btn,
.category-dropdown {
	position: relative;
	.exclamation {
		position: absolute;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		top: 7px;
		right: 25px;
		background: red;
		border: 1px solid black;
		color: white;
	}
}

.category-dropdown {
	position: relative;
	width: 100%;
	height: 33px;

	.all-icon {
		margin-right: 4px !important;
		margin-left: 2px !important;
	}

	select {
		display: none;
	}

	.select-container {
		position: relative;
		border-radius: 4px;
		border: 1px solid var(--v-tab-base);
		background-color: transparent;
		padding: 4px 9px;
		cursor: pointer;
	}

	.selected-option {
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.options {
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background-color: var(--v-base-base) !important;
		border: 1px solid var(--v-tab-base);
		border-radius: 4px;
		display: none;
		/* max-height: 162px; */
		overflow-y: auto;
		z-index: 999;

		.option {
			min-height: 32px !important;
			padding: 0 8px;
			transition: background-color 0.3s;
		}

		.option:hover {
			background: var(--v-activeListItem-base) !important;
			cursor: pointer;
		}
	}
}

/* .category-dropdown select {
	display: none;
} */

/* .category-dropdown::after {
      content: '\E5C5';
      font-family: 'Material Icons';
      font-size: 1.2em;
      color: #555;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      cursor: pointer;
    } */

/* .category-dropdown .select-container {
	position: relative;
	border: 1px solid #fff;
	border-radius: 4px;
	background-color: transparent;
	padding: 4px 12px;
	cursor: pointer;
} */

/* .category-dropdown .selected-option {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
} */

/* .category-dropdown .options {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	background-color: var(--v-base-base) !important;
	border-radius: 4px;
	display: none;
	max-height: 162px;
	overflow-y: auto;
	z-index: 999;
} */

/* .category-dropdown .option {
	min-height: 32px !important;
	padding: 0 9px;
	transition: background-color 0.3s;
} */

/* .category-dropdown .option:hover {
	background: var(--v-activeListItem-base) !important;
	cursor: pointer;
} */
</style>
